(()=>{
  if (!customElements.get("product-description")) {
    class ProductDescription extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.setProperties();
        this.setEventListeners();
      }
  
      disconnectedCallback() {
        this.removeEventListeners();
      }
  
      setProperties() {
        this.toggleBtn = this.querySelector('[data-toggle-description]');
        this.shortText = this.querySelector('[data-product-description-short]');
        this.fullText = this.querySelector('[data-product-description-full]');
        this.readMoreText = this.getAttribute('data-read-more-text');
        this.readLessText = this.getAttribute('data-read-less-text');

        this.buttonContent = {
          read_more: this.readMoreText,
          show_less: this.readLessText,
        }

        this.toggleButtonHandle = this.onBtnToggle.bind(this);
      }
  
      setEventListeners() {
        this.toggleBtn.addEventListener('click', this.toggleButtonHandle);
      }
  
      onBtnToggle() {
        const isHidden = this.fullText.classList.contains('hidden');

        if (isHidden) {
          this.shortText.classList.add('hidden');
          this.fullText.classList.remove('hidden');
          this.toggleBtn.textContent = this.buttonContent.show_less;
        } else {
          this.fullText.classList.add('hidden');
          this.shortText.classList.remove('hidden');
          this.toggleBtn.textContent = this.buttonContent.read_more;
        }
      }
  
      removeEventListeners() {
        this.toggleBtn.removeEventListener('click', this.toggleButtonHandle);
      }
    }
  
    customElements.define("product-description", ProductDescription);
  }
})()